export default __webpack_public_path__ + "static/media/offer6.c33bacc6.jpg";